// import localForage from "localforage";
import { configureStore } from "@reduxjs/toolkit";

import { reducer as routeReducer } from "./route";
import { reducer as adminReducer } from "./admin";
import { reducer as hotelsReducer } from "./hotels";
import { reducer as categoriesReducer } from "./categories";
import { reducer as publicKeysReducer } from "./public-keys";
import { reducer as routesListReducer } from "./routes-list";
import { reducer as routeAuthStateReducer } from "./route-auth";
import { reducer as routeRequestReducer } from "./route-request";
import { reducer as placesUploadReducer } from "./places-upload";
import { reducer as routeResponseReducer } from "./route-response";

// const localeStore = localForage.createInstance({ name: "@route_planner" });

// const saveStorageOnReload = async (
//   state: ReturnType<typeof store.getState>
// ) => {
//   await localeStore.setItem("@state", JSON.stringify(state));
// };

// const loadFromLocalStorage = async () => {
//   const item: any = await localeStore.getItem("@state");
//   const state = item ? JSON.parse(item) : undefined;
//   return state;
// };

// const persistedStore =
//   process.env.NODE_ENV === "development"
//     ? await loadFromLocalStorage()
//     : undefined;

export const store = configureStore({
  reducer: {
    admin: adminReducer,
    route: routeReducer,
    hotels: hotelsReducer,
    categories: categoriesReducer,
    publicKeys: publicKeysReducer,
    routesList: routesListReducer,
    placesUpload: placesUploadReducer,
    routeRequest: routeRequestReducer,
    routeResponse: routeResponseReducer,
    routeAuthState: routeAuthStateReducer,
  },
  // preloadedState: persistedStore,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

store.subscribe(() => {
  if (process.env.NODE_ENV === "development") {
    // void saveStorageOnReload(store.getState());
  }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
